<template>
    <template v-for="(cards,index) in getContent" :key="cards.id">
        <ul class="list mob-top-nav-list temp-menu" v-if="cards.category_name === 'Секрет'">
            <li class="list__element bottom-nav-list__element">
                <a href="/catalog/male/secret" :class="store.state.settings.gender === 'male' ? 'router-link-active':''" class="bottom-nav-list__link">{{ trans('Male')}}</a>
            </li>
            <li class="list__element bottom-nav-list__element">
                <a href="/catalog/female/secret" :class="store.state.settings.gender === 'female' ? 'router-link-active':''" class="bottom-nav-list__link">{{ trans('Female')}}</a>
            </li>
        </ul>
        <div class="catalog-sec__control-row" v-if="cards.items.length > 0">
            <h3 class="category-title">{{ cards.category_name }} </h3>
        </div>
        <div class="product-row ">
            <template v-for="(card, cardIndex) in checkItems(cards)" :key="card.id">
                <product-card
                    :card="card"
                    :item-list-id="listId(cards)"
                    :item-list-name="cards.category_name"
                    :index="cardIndex + 1"
                ></product-card>
            </template>
        </div>
        <div class="catalog-sec__btn-row" v-if="!isSubcategoriesCatalog && cards.items.length >= 9 && cards.items.length >= cards.items_show">
            <button @click.prevent="showMore(cards, index)" class="btn btnV1">{{
                    trans('Show more')
                }}
            </button>
        </div>
    </template>
</template>


<script>
import ProductCard from '../../components/product-card.vue';
import store from '../../store.js';
import { catalogListId, viewItemList } from '../../services/ga4Ecommerce.js';

export default {
    components: {
        ProductCard,
    },
    props: {
        menus: Object,
    },
    data() {
        return {
            cards: [],
        };
    },
    mounted() {
        if (this.menus.type == undefined || this.menus.type !== 'subcategories') {
            this.cards = this.menus.sort((a, b) => (a.sort > b.sort) ? 1 : -1);
            this.cards.forEach((element) => {
                element.items.sort((a, b) => (a.sort < b.sort) ? 1 : -1);
            });
        } else {
            this.cards = this.menus.cards;
        }
        if (this.$store.state.settings.site_id === 1 && import.meta.env.MODE === 'production' ) {
            _tmr.push({type: 'reachGoal', id: 3290316, value: 2, goal: 'view_category'});
        }
        this.$nextTick(() => {
            this.trackVisibleLists()
        })
    },
    computed: {
        store() {
            return store
        },
        getContent() {
            return this.cards;
        },
        isSubcategoriesCatalog() {
            return this.menus?.type === 'subcategories';
        },
    },
    methods: {
        async updateSortCard(card, menu_id) {
            await axios.get('/api/v1/update-sort-card', {
                params: this.setParam({
                    card_id: card.id,
                    sort: card.sort,
                    menu_id: menu_id,
                    site_id: this.$store.state.settings.site_id,
                    gender_id: this.$store.state.settings.gender === 'male' ? 1 : 2
                }),
            }).then(data => {
                // console.log(data.data)
            });
        },
        async getCards(card = null) {
            this.cards = this.cards.map((item) => {
                console.log(item);
                if (card) {
                    if (item.items.find(value => value.id === card.id)) {
                        item.items.find(value => value.id === card.id).sort = card.sort;
                        this.updateSortCard(card, item.menu_id);
                    }
                }
                item.items.sort((a, b) => (a.sort < b.sort) ? 1 : -1);
                return item;
            });
        },
        itemsShow(items_show, index) {
            this.menus[index] = items_show;
        },
        listId(group) {
            return catalogListId(group)
        },
        trackVisibleLists() {
            (this.cards || []).forEach((group) => {
                viewItemList(this.checkItems(group), this.listId(group), group.category_name)
            })
        },
        showMore(group, index) {
            const previous = group.items_show
            group.items_show += 100
            this.itemsShow(group, index)
            viewItemList(
                group.items.slice(previous, group.items_show),
                this.listId(group),
                group.category_name,
                previous
            )
        },
        checkItems(cards) {
            if (this.isSubcategoriesCatalog) {
                return cards.items;
            }
            return cards.items.slice(0, cards.items_show);
        },
        isSecretCatalog() {
            return window.location.href.includes('secret')
        },
    },

    name: 'index',
};
</script>

<style scoped>
.router-link-active {
    color: red;
}
ul.list.temp-menu {
    display: none;
    margin-bottom: 20px;
    li {
        margin-right: 0px;
        a {
            border: none;
        }
    }
}
@media screen and (max-width: 768px) {
    ul.list.temp-menu {
        display: flex;
    }
}
</style>
